import { Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { ARA_LOGIN_URL } from "../../config";
import { useUserProfile } from "../../hooks/useUserProfile";

export const AuthGuard: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const { isLoading, isError } = useUserProfile();

  useEffect(() => {
    if (!isLoading && isError) {
      window.location.href = `${ARA_LOGIN_URL}${window.location.href}`;
    }
  }, [isLoading, isError]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh"
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
